import { BILL_PAY, EXPERIMENTS } from '~/constants'
import { useExperiment } from '~/hooks/useExperiment'

export const DEFAULT_HEADLINE = 'Automatically raise your credit score with StellarFi'
export const EXPERIMENT_HEADLINE = 'Pay Bills and Raise Credit'

export const useSignupDynamicHeadlineBillsExperiment = utmMediumParam => {
  if (utmMediumParam !== BILL_PAY) {
    return DEFAULT_HEADLINE
  }

  const { enabled, variant } = useExperiment(EXPERIMENTS.SIGNUP_DYNAMIC_HEADLINE_BILLS, true)

  if (enabled && variant === 'v1') {
    return EXPERIMENT_HEADLINE
  }
  return DEFAULT_HEADLINE
}
